export enum CreditScoreType {
  POOR = "POOR", //0,
  FAIR = "FAIR", //580,
  GOOD = "GOOD", //670,
  VERY_GOOD = "VERY_GOOD", //740,
  EXCELLENT = "EXCELLENT", //800,
}
